module.exports = __webpack_public_path__ + "static/img/gz_gx.8418d370.png";